import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors';
import {
  mobile_width_percentage,
  tablet_breakpoint,
  tablet_container_maxwidth,
  desktop_breakpoint,
  desktop_breakpoint_extended,
  desktop_container_maxwidth_compact,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const imageAspectRatios = {
  desktop: { width: 687, height: 485 },
  mobile: { width: 511, height: 369 },
};

const HeroStyles = styled.div`
  background-color: ${Colors.primary.claytonBlue.standard};
  padding-top: 20px;
  position: relative;
  margin-bottom: 40px;

  h1 {
    color: ${Colors.primary.white.standard};
    margin-bottom: 20px;
    text-align: center;
  }

  .h1,
  h1 {
    font-size: 34px;
  }

  .hero-container {
    margin: auto;
    width: ${mobile_width_percentage}%;
  }

  .hero-content {
    background-color: ${Colors.primary.claytonBlue.light};
    background-image: url('/public-assets/images/hero_bg.svg');
    background-position: center bottom;
    background-repeat: no-repeat;
    background-size: 100%;
    min-height: 425px;
    margin-bottom: 10px;
    margin: auto;
    position: relative;
  }

  .hero-image {
    height: 200px;
    overflow: hidden;
    position: relative;
    width: 100%;

    img {
      width: 110%;
      object-fit: cover;
    }
  }

  .hero-cta {
    align-items: flex-start;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px 20px 40px;
  }

  .hero-cta-header {
    margin-bottom: 25px;
  }

  .label {
    color: ${Colors.accent.grey2.standard};
  }

  .hero-bottom-cover {
    background-color: ${Colors.primary.white.standard};
    bottom: 0;
    left: 0;
    height: 125px;
    margin-bottom: -1px;
    position: absolute;
    width: 100%;
  }

  .cta-button-outline {
    border-color: ${(props) =>
      props.borderColor ? props.borderColor : Colors.primary.white.standard};
  }

  @media screen and (min-width: ${tablet_breakpoint}px) {
    .hero-cta-header {
      word-break: normal;
    }
  }

  @media screen and (min-width: 768px) {
    .hero-image {
      img {
        width: auto;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .hero-content {
      width: ${tablet_container_maxwidth}px;
    }
  }

  @media screen and (min-width: ${desktop_breakpoint}px) {
    .hero-container {
      max-width: none;
      padding: 0;
    }

    .hero-image {
      height: 240px;

      img {
        object-fit: none;
      }
    }
  }

  @media screen and (min-width: ${desktop_breakpoint_extended}px) {
    h1 {
      padding-bottom: 20px;
    }

    h1,
    .h1 {
      font-size: 40px;
    }

    .hero-container {
      max-width: ${desktop_container_maxwidth_compact}px;
    }

    .hero-content {
      background-position: left bottom;
      background-size: 80%;
      margin: 0;
      width: 80%;
    }

    .hero-cta {
      min-height: 425px;
      justify-content: center;
      padding: 20px 40px;
      width: 50%;
    }

    .hero-image {
      left: 50%;
      height: calc(100% - 60px);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 75%;
    }
  }
`;

export default HeroStyles;
